import {call, put, takeLatest} from 'redux-saga/effects';
import TotalActiveUsersApi from '../../api/TotalActiveUsersApi';
import activeUsersActions from '../../actions/fortnite-game/activeUsers.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getActiveUsers(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(TotalActiveUsersApi.getData, action.payload);
        yield put(
            activeUsersActions.getActiveUsersSuccess({
                data,
                error: data.list && data.list.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(activeUsersActions.getActiveUsersFailed(getErrorCodeFromResponse(e), e));
    }
}

function* activeUsersSaga() {
    yield takeLatest(activeUsersActions.TYPES.GET_ACTIVE_USERS, getActiveUsers);
}

export default activeUsersSaga;
